import { NgClass } from '@angular/common';
import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'ui-switch-toggle',
  standalone: true,
  imports: [NgClass],
  templateUrl: './switch-toggle.component.html',
  styleUrls: ['./switch-toggle.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SwitchToggleComponent),
      multi: true
    }
  ]
})
export class SwitchToggleComponent implements OnInit, ControlValueAccessor {
  @Input() id: string;
  @Input() label: string;
  @Input() description?: string;
  @Input() set enabled(v: boolean) {
    this.value = v;
  }

  @Input() disabled: boolean;
  @Input() showIcon = false;

  private _value: boolean;

  get value(): boolean {
    return this._value;
  }

  set value(v: boolean) {
    if (v !== this._value) {
      this._value = v;
      this.onChangeCb(v);
    }
  }

  @Output() changeValue = new EventEmitter<boolean>();

  ngOnInit(): void {
    this.id = this.id
      ? this.id
      : `liv-switch-toggle-${Math.random()
          .toString()
          .substring(2, length ? length : 6)}`;
  }

  onInputChange(_: Event): void {
    this.value = !this.value;
    this.changeValue.emit(this.value);
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onChangeCb: (_: boolean) => void = () => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onTouchedCb: (_: boolean) => void = () => {};

  writeValue(v: boolean): void {
    this.value = v;
  }

  registerOnChange(fn: (_v: boolean) => void): void {
    this.onChangeCb = fn;
  }

  registerOnTouched(fn: (_v: boolean) => void): void {
    this.onTouchedCb = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
